import { render, staticRenderFns } from "./BaseCampaignForm.vue?vue&type=template&id=2a6d4c7d&scoped=true&"
import script from "./BaseCampaignForm.vue?vue&type=script&lang=js&"
export * from "./BaseCampaignForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BaseCampaignForm.vue?vue&type=style&index=1&id=2a6d4c7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d4c7d",
  null
  
)

export default component.exports